// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore Cannot find module 'redux' or its corresponding type declarations.ts(2307)
import { Action, Reducer } from 'redux';

type ReducersMap = Record<string, Reducer<unknown, Action>>;
type EmitChange = (reducers: ReducersMap) => Promise<boolean>;

export class ReducerRegistry {
  _emitChange: EmitChange | null = null;

  _reducers: ReducersMap = {};

  constructor(initialReducers: ReducersMap = {}) {
    this._emitChange = null;
    this._reducers = { ...initialReducers };
  }

  getReducers() {
    return { ...this._reducers };
  }

  async register(name: string, reducer: Reducer) {
    if (!this._reducers[name]) {
      console.log('Registering async reducer:', name);

      this._reducers = { ...this._reducers, [name]: reducer };

      return Promise.resolve().then(() => {
        if (this._emitChange) {
          return this._emitChange(this.getReducers());
        }

        return false;
      });
    }

    return true;
  }

  setChangeListener(listener: EmitChange) {
    this._emitChange = listener;
  }
}
